export default __webpack_public_path__ + "static/media/search-icon.982ef9c8.svg";